<footer>
  <section class="container">
    <div class="row-fluid" *ngIf="isDataAvailable">
      <div class="footer-menu col-sm-12" *ngIf="!loginPage">
        <ul>
          <li *ngFor="let item of footerData.mainLinks[0].displayItems">
            <!-- <a href="">{{ item.keyText }}</a> -->

            <a
              href="javascript:void(0);"
              (click)="footerLink(item)"
              [title]="item.keyText"
              >{{ item.keyText }}</a
            >
          </li>
        </ul>
      </div>
      <div class="social footer-social">
        <ul>
          <li
            class="social-icon"
            [ngClass]="{
              'social-icon--twitter': item.keyText == 'Twitter',
              'social-icon--vimeo': item.keyText == 'Vimeo',
              'social-icon--linkedin': item.keyText == 'LinkedIn'
            }"
            *ngFor="let item of footerData.socialLinks[0].displayItems"
          >
            <a [href]="item.navigation.Url" target="_blank">
              <svg xmlns="" viewBox="0 0 35.6 35.6">
                <title>{{ item.keyText }}</title>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      [ngClass]="{
                        'cls-1twitter': item.keyText == 'Twitter',
                        'cls-1vimeo': item.keyText == 'Vimeo',
                        'cls-1linkedin': item.keyText == 'LinkedIn'
                      }"
                      [attr.d]="item.icon"
                    />
                    <circle
                      [ngClass]="{
                        'cls-2twitter': item.keyText == 'Twitter',
                        'cls-2vimeo': item.keyText == 'Vimeo',
                        'cls-2linkedin': item.keyText == 'LinkedIn'
                      }"
                      cx="17.8"
                      cy="17.8"
                      r="16.8"
                    ></circle>
                  </g>
                </g>
              </svg>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-additional row padding-left-lg-30">
        <ul class="col-xs-12 col-lg-5 footer-link-sm">
          <li *ngFor="let item of footerData.subLinks[0].displayItems">
            <a
              [href]="item.navigation.Url"
              target="_blank"
              [title]="item.keyText"
              >{{ item.keyText }}</a
            >
          </li>
        </ul>
        <p
          class="col-xs-12 col-lg-7 align-lg"
          [innerHTML]="footerData.messages[0].description"
        ></p>
      </div>
    </div>
  </section>
</footer>
